module.exports = __webpack_public_path__ + "static/media/howItWorks-2.8559f812.svg";